// Phase 129 — takeover overlay.
//
// Renders inside the demo section when the SSE stream receives a `taken_over`
// event (multi-tab "Use Here" flow). Composition follows DESIGN.md: dark
// immersive surface (#181A1B), 24px card radius, dual-shadow elevation, pill
// (100px) Meta Blue (#0064E0) primary CTA, generous gallery padding.
//
// The chat content behind this overlay renders dimmed at opacity-40 with
// pointer-events-none — that visual treatment lives in DemoChatPanel via the
// `dimmed` prop. This component sits on top as a separate layer.
//
// Copy is short and direct — no em dashes per the CLAUDE.md / project memory
// rule. Button label is Title Case.
interface DemoTakeoverOverlayProps {
  onReclaim: () => void | Promise<void>;
}

export function DemoTakeoverOverlay({ onReclaim }: DemoTakeoverOverlayProps) {
  const handleClick = (): void => {
    void onReclaim();
  };

  return (
    <div
      data-testid="demo-takeover-overlay"
      className="absolute inset-0 z-10 flex items-center justify-center px-6"
    >
      {/* Backdrop scrim — keeps the dimmed chat visible underneath. */}
      <div
        aria-hidden="true"
        className="absolute inset-0 rounded-[24px] bg-black/55 backdrop-blur-sm"
      />
      {/* Card */}
      <div
        role="dialog"
        aria-labelledby="demo-takeover-heading"
        aria-describedby="demo-takeover-body"
        className="relative w-full max-w-md rounded-[24px] bg-[#181A1B] border border-white/10 p-8 md:p-10 text-center shadow-[0_12px_28px_rgba(0,0,0,0.2),0_2px_4px_rgba(0,0,0,0.1)]"
      >
        <h3
          id="demo-takeover-heading"
          className="text-2xl font-medium tracking-[-0.01em] text-white"
        >
          Connected In Another Tab
        </h3>
        <p
          id="demo-takeover-body"
          className="mt-3 text-base leading-relaxed text-white/65"
        >
          Your demo number moved to a different tab. Use Here to bring it back.
        </p>
        <button
          type="button"
          onClick={handleClick}
          className="mt-6 inline-flex h-11 items-center justify-center rounded-[100px] bg-[#0064E0] px-8 text-sm font-medium tracking-tight text-white transition hover:bg-[#0143B5] active:bg-[#004BB9] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#0064E0] focus-visible:ring-offset-2 focus-visible:ring-offset-[#181A1B] shadow-[0_8px_24px_rgba(0,100,224,0.35)]"
        >
          Use Here
        </button>
      </div>
    </div>
  );
}
